import { isHandoutWordLayout } from "./handoutWordLayout";
export const getQuestionPaginationPayload = (question) => Object.fromEntries(
  [["widowControl", "widow_control"], ["keepWithNext", "keep_with_next"], ["keepTogether", "keep_together"]]
    .filter(([key]) => typeof question.pagination?.[key] === "boolean")
    .map(([key, output]) => [output, question.pagination[key]]),
);

export const getQuestionPaginationStyle = (question) => ({
  breakInside: question.pagination?.keepTogether ? "avoid" : "auto",
  breakAfter: question.pagination?.keepWithNext ? "avoid" : "auto",
  widows: question.pagination?.widowControl === false ? 1 : 2,
  orphans: question.pagination?.widowControl === false ? 1 : 2,
});

// Earlier editor versions created timestamp IDs without recording this flag.
// Keep those user-inserted breaks distinct from imported page-break-1 markers.
export const isExplicitHandoutPageBreak = (section) => section?.type === "page_break" &&
  (section.forcePageBreak === true || /^page_break-\d{13}-[a-z0-9]+$/.test(String(section.id || "")));

export const handoutBreakIsEnabled = (section, settings = {}) => section?.type === "section_break" ||
  (section?.type === "page_break" && (isExplicitHandoutPageBreak(section) || settings.preserveManualPageBreaks !== false));

export const needsQuestionPageBreak = (question, index, previousSection, settings = {}) => Boolean(
  question.pageBreakBefore && !(index === 0 && handoutBreakIsEnabled(previousSection, settings)),
);

export const needsStandalonePageBreak = (section, index, sections, settings = {}) =>
  section.type === "section_break" || (section.type === "page_break" && handoutBreakIsEnabled(section, settings) &&
    !handoutBreakIsEnabled(sections[index - 1], settings));

export const needsChapterPageBreak = (section, index, sections, settings = {}) => {
  if (!isHandoutWordLayout(settings) || section.type !== "focus" || !section.chapter ||
      !sections.slice(0, index).some((previous) => previous.type === "focus" && previous.chapter)) return false;
  // A rendered adjacent boundary already starts the unit's column. Old block
  // breaks skipped by reflow do not, and must not suppress the unit boundary.
  for (let previous = index - 1; previous >= 0 && ["page_break", "section_break"].includes(sections[previous].type); previous -= 1) {
    if (needsStandalonePageBreak(sections[previous], previous, sections, settings)) return false;
  }
  return true;
};

export const getForcedHandoutPageCount = (sections, settings = {}) => 1 + sections.reduce((count, section, sectionIndex) =>
  count + (needsStandalonePageBreak(section, sectionIndex, sections, settings) ? 1 : 0) +
  (needsChapterPageBreak(section, sectionIndex, sections, settings) ? 1 : 0) +
  (section.questions || []).filter((question, index) => needsQuestionPageBreak(question, index, sections[sectionIndex - 1], settings)).length,
0);
